import { Button } from '../ui/Button';
import React, { useCallback, useState } from 'react';
import { SectionContainerTransparent, StyledTextInput } from './AuthCommonStyledComponents';
import { signIn } from 'aws-amplify/auth';
import { $authFlow } from '../store/auth';
export const EmailForm = () => {
  const [email, setEmail] = useState<string>("")
  const [emailValidity, setEmailValidity] = React.useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const onStartSignIn = useCallback(async () => {
    if (!email || email.length === 0 || !emailValidity) {
      console.error("Email is required for sign in")
      return
    }
    $authFlow.setKey('persistentData', {
      email: email
    })
    try {
      setIsLoading(true)
      const { nextStep: signInNextStep } = await signIn({
        username: email,
        options: {
          authFlowType: "USER_AUTH",
          preferredChallenge: "EMAIL_OTP"
        }
      })

      if (signInNextStep.signInStep === "CONFIRM_SIGN_IN_WITH_EMAIL_CODE") {
        $authFlow.setKey('validationFrom', 'email')
        $authFlow.setKey('state', 'confirm')
      }
    } catch (error) {
      try {
        const preAuthLambdaReturnedError = (error as Error).message.match(
          /^PreAuthentication failed with error (.*)\./
        )?.[1]
        if (!preAuthLambdaReturnedError) {

          const alreadyAuthenticatedError = (error as Error).message.includes('UserAlreadyAuthenticatedException')
          if (alreadyAuthenticatedError) {
            console.log('Reload: UserAlreadyAuthenticatedException')
            window.location.reload()
            return;
          }

          if (error?.toString() === 'UserAlreadyAuthenticatedException: There is already a signed in user.') {
            console.log('Reload: UserAlreadyAuthenticatedException')
            window.location.reload()
            return;
          }
          throw new Error("Unexpected error during sign in: " + error)
        }
        const { userNotFound } = JSON.parse(preAuthLambdaReturnedError)
        if (userNotFound) {
          console.log("User not found, starting sign up flow...")
          $authFlow.setKey('state', 'signup')
          return
        }
      } catch (errorParseError) {
        console.error(
          "Error during parsing pre auth error message:",
          errorParseError
        )
        // Here we need to set the login error state to handle it accordingly
      }
    } finally {
      setIsLoading(false)
    }
  }, [email, emailValidity])

  return (
    <SectionContainerTransparent title={'Login or Sign Up'}>
      <StyledTextInput
        label="Email"
        type="email"
        placeholder="Type your email address..."
        onChange={emailChange => {
          setEmail(emailChange)
        }}
        value={email}
        required
        onValidityChange={setEmailValidity}
        transparent={false}
      />
      <Button
        large
        disabled={isLoading || !emailValidity}
        onClick={() => {
          void onStartSignIn()
        }}
      >
        next
      </Button>
    </SectionContainerTransparent>
  )
}